export const pluralise = (singular: string, plural: string, count: number) => (count === 1 ? singular : plural);

export function capitalizeFirst(s?: string, lowercase = false) {
  if (!s) { return ""; }
  const first = s?.charAt(0);
  const rest = s?.slice(1);
  return first.toUpperCase() + (lowercase ? rest.toLowerCase() : rest);
}

export const transformSnakeCaseToSentenceCase = (input: string): string => input
  .split("_")
  .filter(Boolean)
  .map((word, index) => (index === 0
    ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    : word.toLowerCase()))
  .join(" ");

export const isPositiveIntegerString = (s: string) => /^[1-9]\d*$/.test(s.trim());

export const snakeToCamel = (str: string): string => {
  if (!str.includes("_")) {
    if (str === str.toUpperCase()) { return str.toLowerCase(); }
    return str.charAt(0).toLowerCase() + str.slice(1);
  }
  return str.toLowerCase()
    .replaceAll(/_([a-zA-Z0-9])/g, (_, c) => c.toUpperCase());
};

export const snakeToPascal = (str: string): string => {
  const camel = snakeToCamel(str);
  return camel.charAt(0).toUpperCase() + camel.slice(1);
};

type TSnakeCaseToCamelCase<TValue extends string> =
  TValue extends `${infer THead}_${infer TTail}`
    ? `${Lowercase<THead>}${Capitalize<TSnakeCaseToCamelCase<TTail>>}`
    : Lowercase<TValue>;

export function snakeCaseToCamelCase<const TValue extends string>(s: TValue): TSnakeCaseToCamelCase<TValue>;
export function snakeCaseToCamelCase(s?: string): string;
export function snakeCaseToCamelCase(s?: string): string {
  if (!s) return "";
  const [ first, ...rest ] = s.toLowerCase().split("_");
  return first + rest.map((word) => capitalizeFirst(word, true)).join("");
}

export const valueOrEmptyString = (value: string | undefined | null) => (
  value || ""
);
